import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'multipleEntitiesList', 'multipleEntitiesToggle', 'multipleEntityInput' ]

  connect() {
    this.toggle()
  }

  toggle() {
    if (this.multipleEntitiesToggleTarget.checked) {
      this.multipleEntitiesListTarget.classList.remove('hidden')
      this.multipleEntityInputTargets.forEach((element) => {
        element.disabled = false
      })
    } else {
      this.multipleEntitiesListTarget.classList.add('hidden')
      this.multipleEntityInputTargets.forEach((element) => {
        element.disabled = true
        if (element.value === "") {
          element.closest('.nested-form-wrapper').remove()
        }
      })
    }
  }
}
